'use client';

import { useEditableDotCMSPage } from '@dotcms/react';
import ErrorPage from './errorPage';

export function NotFoundPage({ pageResponse, errorDescription, errorMessage }) {
    useEditableDotCMSPage(pageResponse);

    return <ErrorPage errorDescription={errorDescription} errorMessage={errorMessage} />;
}
